import { ApplicationRoles } from '../../../constants/applicationRoles.ts';
import applicationRoutes from '../../../constants/applicationRoutes.ts';
import { RouteAuthenticationRequirement, RouteItem } from '@cks-internal/react-base';
import Layout from '../../../app/Layout.tsx';

export const AdminNavItems: RouteItem = {
  text: 'Admin',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [ApplicationRoles.userAdmin, ApplicationRoles.systemAdmin],
  layout: <Layout />,
  subItems: [
    {
      text: 'Manage Users',
      path: applicationRoutes.admin.users,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,

      allowedRoles: [ApplicationRoles.userAdmin],
      async lazy() {
        const component = await import('../../../features/userAdmin/ManageUsers.tsx');
        return { Component: component.ManageUsers };
      }
    },
    {
      text: 'CRM Management',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.admin.crmManagement,
      allowedRoles: [ApplicationRoles.systemAdmin],
      async lazy() {
        const component = await import('../../../features/crmAdmin/CrmManagement.tsx');
        return { Component: component.CrmManagement };
      }
    },
    {
      text: 'Email/SMS Templates',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.admin.emailSignatures,
      allowedRoles: [ApplicationRoles.systemAdmin],
      async lazy() {
        const component = await import('../../../features/emailSmsAdmin/EmailSignatureManagement.tsx');
        return { Component: component.EmailSignatureManagement };
      }
    },
    {
      text: 'Announcements',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.admin.announcement,
      allowedRoles: [ApplicationRoles.systemAdmin],
      async lazy() {
        const component = await import('../../../features/crmAdmin/announcements/AnnouncementManagement.tsx');
        return { Component: component.AnnouncementManagement };
      }
    },
    {
      path: applicationRoutes.admin.passThrough,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.developer],
      async lazy() {
        const component = await import('../../../app/ApiPassthrough.tsx');
        return { Component: component.ApiPassthrough };
      }
    },
    {
      text: 'System Management',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.admin.systemManagement,
      allowedRoles: [ApplicationRoles.systemAdmin],
      async lazy() {
        const component = await import('../../../features/systemAdmin/SystemManagement.tsx');
        return { Component: component.SystemManagement };
      }
    },
    {
      text: 'Agent Activity Report',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.reporting.agentActivityReportV2,
      allowedRoles: [ApplicationRoles.systemAdmin],
      async lazy() {
        const component = await import('../../../features/reporting/agentActivityReport/AgentActivityReport.tsx');
        return { Component: component.AgentActivityReport };
      }
    },
    {
      text: 'Agent Folio Report',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.reporting.folioActivityReport,
      allowedRoles: [ApplicationRoles.systemAdmin],
      async lazy() {
        const component = await import('../../../features/reporting/agentActivityReport/FolioAgentReport.tsx');
        return { Component: component.FolioAgentReportTable };
      }
    },
    {
      text: 'Reconciliation Report',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.reporting.reconciliationReport,
      allowedRoles: [ApplicationRoles.systemAdmin],
      async lazy() {
        const component = await import('../../../features/reporting/reconciliationReport/ReconciliationReport.tsx');
        return { Component: component.ReconciliationReport };
      }
    }
  ]
};
